<template>
  <div class="index">
    <!-- 导航栏 -->
    <nav-header :href="this.href"></nav-header>
    <div class="banner">
      <img src="/imgs/banner2.jpg" alt="" />
    </div>
    <div class="container">
      <!-- 轮播 + 介绍 区块 st-->
      <div class="top">
        <!-- 左侧轮播 -->
        <div class="sw">
          <swiper :options="swiperOption">
            <swiper-slide v-for="(item, index) in list" :key="index">
              <img :src="item.img" alt="" style="width: 100%;height: 100%;">
              <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div>
            </swiper-slide>
          </swiper>
        </div>

        <!-- 右侧介绍 -->
        <div class="js">
          <h2>{{ this.cmName }}</h2>
          <p>
            整个系列付费下载动漫包
          </p>
          <p>下载费用：15元</p>
          <div class="btn" @click="alipay([], 1 + 1, 15)">
            立即下载
          </div>
        </div>
      </div>
      <!-- 轮播 + 介绍 区块 end-->

      <h4>部分产品</h4>
      <!-- 图片列表 st -->
      <div class="list-con">
        <!-- 循环项 -->
        <div class="item" v-for="(item, index) in cnList" :key="index">
          <img :src="item.img" alt="">
        </div>
      </div>
      <!-- 图片列表 end -->
    </div>
  </div>
</template>

<script>
import NavHeader from "./../components/NavHeader";
export default {
  components: {
    NavHeader
  },
  data() {
    return {
      state: JSON.parse(window.localStorage.getItem("state")),
      logo_user: JSON.parse(window.localStorage.getItem("user")),
      href: "index.html",
      // 获取 id
      myId: this.$route.query.type,
      // 动漫标题
      cmName: '',
      // 动漫数组
      cnList: [],
      // 轮播数组
      list: [

      ],
      // 轮播配置
      swiperOption: {
        loop: true,
        autoplay: true,
        navigation: { // 前进后退按钮
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        speed: 100
      }
    };
  },

  mounted() {
    this.init();
    document.title = "晋江奇境";
  },
  methods: {
    init() {
      this.axios.get("/mock/sound.json").then((res) => {
        var vl = res.data;
        if (this.myId == 1) {
          var abc = vl.slice(0, 21)
          this.list = abc.slice(0, 10)
          this.cnList = abc.slice(0, 10)
          this.cmName = '胖猫暴躁'
        } else if (this.myId == 2) {
          var abc2 = vl.slice(21, 41)
          this.list = abc2.slice(0, 10)
          this.cnList = abc2.slice(0, 10)
          this.cmName = '仙人掌 '
        } else if (this.myId == 3) {
          var abc3 = vl.slice(41, 58)
          this.list = abc3.slice(0, 10)
          this.cnList = abc3.slice(0, 10)
          this.cmName = '小龙人 '
        } else if (this.myId == 4) {
          var abc4 = vl.slice(58, 74)
          this.list = abc4.slice(0, 10)
          this.cnList = abc4.slice(0, 10)
          this.cmName = '粉发女孩 '
        } else if (this.myId == 5) {
          var abc5 = vl.slice(74, 108)
          this.list = abc5.slice(0, 10)
          this.cnList = abc5.slice(0, 10)
          this.cmName = '鸭鸭系列 '
        } else if (this.myId == 6) {
          var abc6 = vl.slice(108, 125)
          this.list = abc6.slice(0, 10)
          this.cnList = abc6.slice(0, 10)
          this.cmName = '胖胖兔 '
        } else if (this.myId == 7) {
          var abc7 = vl.slice(125, 141)
          this.list = abc7.slice(0, 10)
          this.cnList = abc7.slice(0, 10)
          this.cmName = '蜜蜂女孩 '
        }
        else if (this.myId == 8) {
          var abc8 = vl.slice(141, 169)
          this.list = abc8.slice(0, 10)
          this.cnList = abc8.slice(0, 10)
          this.cmName = '黑脸羊 '
        } else if (this.myId == 9) {
          var abc9 = vl.slice(169, 192)
          this.list = abc9.slice(0, 10)
          this.cnList = abc9.slice(0, 10)
          this.cmName = '猫头鹰 '
        }
        else if (this.myId == 10) {
          var abc10 = vl.slice(192, 221)
          this.list = abc10.slice(0, 10)
          this.cnList = abc10.slice(0, 10)
          this.cmName = '蓝衣女孩 '
        }
        else if (this.myId == 11) {
          var abc11 = vl.slice(220, 232)
          this.list = abc11.slice(0, 12)
          this.cnList = abc11.slice(0, 12)
          this.cmName = '兔子 '
        }
        else if (this.myId == 12) {
          var abc12 = vl.slice(232, 244)
          this.list = abc12.slice(0, 12)
          this.cnList = abc12.slice(0, 12)
          this.cmName = '老虎 '
        }
        // var date = vl.find((vl) => vl.id == this.myId);
      });
    },
    // 真实支付
    alipay(data, index, price) {
      console.log(data);
      var payAmount = price; //支付价格
      var orderName = "会员支付下载"; //订单名称
      var id = index; //订单名称
      var userName = this.logo_user.username;
      window.open(
        "http://www.jjqj.net/alipay/index.php?payAmount=" +
        payAmount +
        "&orderName=" +
        orderName +
        "&id=" +
        id +
        "&userName=" +
        userName
      );
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.index {
  .banner {
    width: 100%;
    height: 450px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .container {
    .top {
      width: 100%;
      height: 456px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 40px 0;

      .sw {
        width: 40%;
        height: 100%;
        text-align: center;

        .swiper-wrapper {
          width: 100% !important;
          height: 100% !important;
        }
      }

      .js {
        flex: 1;
        height: 100%;
        padding: 30px 0 0 30px;
        box-sizing: border-box;
        margin-left: 35px;

        h2 {
          margin: 30px 0;
        }

        p {
          margin: 25px 0;
          font-size: 16px;
          color: #333;
        }
      }
    }

    // 图片列表
    .list-con {
      width: 100%;
      margin: 0 0 40px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;

      // 循环项
      .item {
        width: 200px;
        height: 200px;
        margin: 30px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

  }
}
</style>
